export default __webpack_public_path__ + "static/firmaDirector-173ef2a5862bc14da103e168798ea1e8.png";